import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-infodialog',
  templateUrl: './infodialog.component.html',
  styleUrls: ['./infodialog.component.css']
})
export class InfoDialogueComponent implements OnInit {

  ok = this.translocoService.translate('ok') === 'ok' ? 'OK' : this.translocoService.translate('ok');
  refresh = this.translocoService.translate('Refresh') === 'Refresh' ? 'Refresh' : this.translocoService.translate('Refresh');


  constructor(
    private dialogRef: MatDialogRef<InfoDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translocoService: TranslocoService) { }


  ngOnInit(): void {

  }

  okClicked = () => {
    this.dialogRef.close(this.data.error);
  }

}
